import './styles.css';

// Core
import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Components
import {
	GeckoCol,
	GeckoRow
} from '@geckolabs/gecko-react-ui';

// Services
import DateUtils from '../../services/DateUtils';
import moment from 'moment';

export default class SessionTime extends Component {

	combineClasses(...args)
	{
		return args.reduce((accumulator, currentValue) => {
			if (Array.isArray(currentValue)) {
				return accumulator + ' ' + currentValue.join(' ');

			} else if (typeof currentValue === 'string') {
				return accumulator + ' ' + currentValue;
			}

			return accumulator;
		}, '');
	}

	renderSessionTime() 
    {
        if (!this.props.start || !this.props.end) {
            return null;
        }

        const column_default_classes = [
        	'col-4',
        	'flex-column',
        	'd-flex',
        	'justify-content-center',
        	'text-center',
        	'sessionTimeComponent',
        ];

        const column_classes = this.combineClasses(column_default_classes, this.props.className);

        let startTime;
        let endTime;

        if (moment(this.props.start).format('ddd D MMM') !== moment(this.props.end).format('ddd D MMM')) {
            startTime = moment(this.props.start).format('Do MMMM');
            endTime = moment(this.props.end).format('Do MMMM');

        } else {
            startTime = moment(this.props.start).format(DateUtils.timeFormat);
            endTime = moment(this.props.end).format(DateUtils.timeFormat);
        }

        if (startTime === endTime) { 
            return (
                <div className={column_classes}>
                    <GeckoRow>
                        <GeckoCol width="sm-12">
                            <div className="stubTime startTime">
                                {startTime}
                            </div>
                        </GeckoCol>
                    </GeckoRow>
                </div>
            );
        }

        return (
            <div className={column_classes}>
                <GeckoRow>
                    <GeckoCol width="sm-12">
                        <div className="stubTime startTime">
                            {startTime}
                        </div>
                    </GeckoCol>
                </GeckoRow>

                <GeckoRow>
                    <GeckoCol width="sm-12">
                        <span className="gecko-ui-icon far">&#xF107;</span>
                    </GeckoCol>
                </GeckoRow>

                <GeckoRow>
                    <GeckoCol width="sm-12">
                        <div className="stubTime startTime">
                            {endTime}
                        </div>
                    </GeckoCol>
                </GeckoRow>
            </div>
        );
    }

    render() {
		return this.renderSessionTime()
    }
}


SessionTime.propTypes = {
    className: PropTypes.oneOfType([
    	PropTypes.string,
    	PropTypes.array,
  	]),
};

SessionTime.defaultProps = {
	start: null,
	end: null,
	className: [],
}

